import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { AppState } from '../../reducers/root.reducer';

const project = (state: AppState) => state.participant.project;

const getProjects = createSelector(project, (project) => project.projects);
const getProjectDetail = createSelector(project, (project) => project.project);
const getConsent = createSelector(project, (project) => project.consent);

function useGetProjects() {
    return useSelector(getProjects);
}

function useGetProjectDetail() {
    return useSelector(getProjectDetail);
}

function useGetConsent() {
    return useSelector(getConsent);
}

const ProjectSelector = {
    getProjects,
    getProjectDetail,
    getConsent,
    useGetProjects,
    useGetProjectDetail,
    useGetConsent,
};

export default ProjectSelector;
